module.exports = __webpack_public_path__ + "img/P.93f17d90.png";